import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { cosmeticBrands, supplementBrands, dentalBrands } from '../data/brands';
import { useTranslation, Trans } from 'react-i18next';

const Brands = () => {
    const { t } = useTranslation();

    const brandSettings = {
        modules: [Autoplay],
        spaceBetween: 15,
        speed: 1200,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        breakpoints: {
            900: { slidesPerView: 4 },
            1100: { slidesPerView: 5 },
            1500: { slidesPerView: 6 }
        }
    };

    return (
        <div className="our-brands section-padding" id="brands-section">
            <h2 className="text-color-bright fs-1 text-center text-capitalize mb-5">
                {t('We work with best partners')}
            </h2>

            <div className="brands container-fluid">
                {/* Cosmetic Brands */}
                <Swiper
                    {...brandSettings}
                    slidesPerView={3}
                    className="mySwiperBrandsCosmetic mb-5"
                >
                    <h2 className="text-main-muted fw-bold text-center">{t('Cosmetic')}</h2>
                    {cosmeticBrands.map(brand => (
                        <SwiperSlide key={brand.id}>
                            <img
                                id={brand.id}
                                src={brand.img_url}
                                alt={brand.alt}
                                height="90"
                                width="140"
                                className="img-fluid"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Supplement Brands */}
                <Swiper
                    {...brandSettings}
                    slidesPerView={3}
                    className="mySwiperBrandsSupplement mb-5"
                >
                    <h2 className="text-main-muted fw-bold text-center">{t('Supplement')}</h2>
                    {supplementBrands.map(brand => (
                        <SwiperSlide key={brand.id}>
                            <img
                                id={brand.id}
                                src={brand.img_url}
                                alt={brand.alt}
                                height="90"
                                width="140"
                                className="img-fluid"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Dental Brands */}
                <Swiper
                    {...brandSettings}
                    slidesPerView={3}
                    className="mySwiperBrandsDental"
                >
                    <h2 className="text-main-muted fw-bold text-center">{t('Dental')}</h2>
                    {dentalBrands.map(brand => (
                        <SwiperSlide key={brand.id}>
                            <img
                                id={brand.id}
                                src={brand.img_url}
                                alt={brand.alt}
                                height="90"
                                width="140"
                                className="img-fluid"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default Brands;